// extracted by mini-css-extract-plugin
export default {"circle":"Circle_circle__Ge5ZT","green":"Circle_green__FWjao","red":"Circle_red__cfpks"};